import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  LoadingOutlined,
  SafetyCertificateOutlined,
  StopOutlined
} from "@ant-design/icons"
import { Tag } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { AnalysisStatus } from "./api/types.ts"

// Every status reads as text plus an icon — colour is never the only signal.
const STATUS: Record<AnalysisStatus, { color: string; icon: React.ReactNode }> =
  {
    created: { color: "default", icon: <FileTextOutlined /> },
    ready: { color: "default", icon: <ClockCircleOutlined /> },
    analyzing: { color: "processing", icon: <LoadingOutlined /> },
    review_required: { color: "blue", icon: <EditOutlined /> },
    pending_approval: { color: "gold", icon: <SafetyCertificateOutlined /> },
    applying: { color: "processing", icon: <LoadingOutlined /> },
    applied: { color: "green", icon: <CheckCircleOutlined /> },
    failed: { color: "red", icon: <CloseCircleOutlined /> },
    apply_failed: { color: "red", icon: <ExclamationCircleOutlined /> },
    cancelled: { color: "default", icon: <StopOutlined /> }
  }

export function StatusTag({ status }: { status: AnalysisStatus }) {
  const { t } = useTranslation()
  const config = STATUS[status] ?? STATUS.created
  return (
    <Tag color={config.color} icon={config.icon} style={{ marginInlineEnd: 0 }}>
      {t(`aiCenter.sowReceivables.status.${status}`)}
    </Tag>
  )
}

export function KindTag({ kind }: { kind: "project" | "lead" }) {
  const { t } = useTranslation()
  return (
    <Tag
      color={kind === "project" ? "blue" : "purple"}
      style={{ marginInlineEnd: 0 }}
    >
      {t(`aiCenter.sowReceivables.common.kind.${kind}`)}
    </Tag>
  )
}
